import $ from 'jquery'
import Splide from '@splidejs/splide'

$('.js-regions-slider').each(function () {
  var $this = $(this)
  var regionsSplide = new Splide($this[0], {
    drag: 'free',
    pagination: false,
    arrows: true,
    fixedWidth: '230px',
    fixedHeight: '255px',
    gap: '30px',
    breakpoints: {
      768: {
        fixedWidth: '210px',
        fixedHeight: '210px',
      },
    },
  })

  regionsSplide.mount()
})
